import { Component } from "react";
import { ColorPickerConstants, White } from "styles/buildertrendTheme/Colors";

import { cn } from "@btnet/utilities-core";

import { leadActivityIconClassMap } from "entity/lead/Common/IconSelectItem";

import { LeadActivityIcon } from "../leadActivityIcon";

interface ILeadActivityIconDisplayProps {
    /**
     * Icon type to be displayed displays empty circle by default
     * @default IconType.None
     */
    icon: LeadActivityIcon;

    /**
     * Color of icon background in hex
     * @default ColorPickerConstants.Sky
     */
    color: string;

    /**
     * Color of icon itself in hex
     * @default White
     */
    iconColor?: string;

    /**
     * Size of the icon
     */
    size?: 1 | 2 | 3 | 4;

    className?: string;
}

export class LeadActivityIconDisplay extends Component<ILeadActivityIconDisplayProps> {
    static defaultProps = {
        icon: LeadActivityIcon.None,
        color: ColorPickerConstants.Sky,
        iconColor: White,
    };

    private getIconClass = (icon: LeadActivityIcon): string => {
        return leadActivityIconClassMap[icon] || "";
    };

    /**
     * Returns the font awesome class for appropriate size
     */
    private get iconSizeClass() {
        switch (this.props.size) {
            case 1:
                return "fa-lg";
            case 2:
                return "fa-2x";
            case 3:
                return "fa-3x";
            case 4:
                return "fa-5x";
            default:
                return "";
        }
    }

    render() {
        const { icon, color, iconColor, className } = this.props;
        const iconClass = this.getIconClass(icon);
        const spanClass = cn(className, "lead-activity-icon", `fa-stack ${this.iconSizeClass}`);

        return (
            <span className={spanClass}>
                <i
                    id="iconBackground"
                    className="fa fa-circle fa-stack-2x"
                    style={{ color: color }}
                />
                <i
                    id="iconImage"
                    className={`${iconClass} fa-stack-1x`}
                    style={{ color: iconColor }}
                />
            </span>
        );
    }
}
